import Card from '@/components/card';
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import MicroApp from '@/common/jmtd-micro-app';
import { mapValues } from 'lodash';

export default function SecKill(props) {
  const filter = props.filter;
  const { buId, deptId1, deptId2, deptId3, deptId4 } = filter;

  return (
    <>
      <Card>
        <div
          onClick={() => {
            props.setSecKill(null);
          }}
          style={{
            color: 'rgba(0, 0, 0, 0.65)',
            'font-weight': 400,
            'font-size': '14px',
            cursor: 'pointer',
          }}
        >
          {'<'} 返回全部频道
        </div>
      </Card>
      <div style={{ background: '#F2F3F5', padding: '16px 0', height: '100%', minHeight: '900px' }}>
        <MicroApp
          src="//storage.360buyimg.com/sz-page-service/build/861-second-kill-54.0.0.js"
          pre
          pageId="861"
          params={{
            userType: filter.userType === 'dept' ? 'cateDeptGlb' : 'cateErpGlb',
            erp: filter.userType === 'dept' ? undefined : props.participant,
            ...mapValues(
              {
                buId,
                deptId1,
                deptId2,
                deptId3,
                deptId4,
              },
              (v) => (v == '全部' ? null : v)
            ),
            realtime:
              filter.realTime == '1' ? '728064f3-1cc8-4e79-b583-747403ec3647' : '776fdfab-8a13-4fd7-bb69-ba842526d095',
          }}
        ></MicroApp>
      </div>
    </>
  );
}
